export default __webpack_public_path__ + "static/media/card-icon.1f19c2c2.svg";